import React, { useEffect, useState }                    from  'react';
import { TextField, MenuItem }  from  '@material-ui/core';
import Styles                   from  './styles';
import FormPageHeader           from  '../../../../../components/shared/FormPageHeader';
import ExpandMoreIcon           from  '@material-ui/icons/ExpandMore';
import { useFormik          }   from  'formik';
import {
        GSTTreatment,
        PlaceOfSupply       }   from  '../../../../../common/common.model';
import validation               from  './validation';
import * as customerService     from  '../customer.service';
import { Customer 			} 	from  '../customer.model';
import { useSnackbar 		} 	from 'notistack';
import {
		showSuccessSnackbar,
		showErrorSnackbar,
		showSnackbar 		} 	from '../../../../../common/common.service';
import Loading from '../../../../../components/shared/Loading';

const inputProps                =   {
  disableUnderline              :   true,
  style                         :   {
    fontSize					:	'14px'
  }
};

export default function AddCustomer (props: any): JSX.Element {
  const snackbar = useSnackbar();
  const classes:any 			= 	Styles();
  let [editMode, setEditMode]   =   useState(false);
  let [loading, setLoading]   =   useState(false);
  const [ patch, setPatch ] = useState(false);

  const formik 					= 	useFormik({
    initialValues				: 	{
      firstName					: 	'',
      lastName					: 	'',
      email						: 	'',
      companyName				: 	'',
      phone						: 	'',
      openingBalance			: 	'-10000',
      address					: 	'',
      city						: 	'',
      state						: 	'',
      zipcode					: 	'',
      gstin						: 	'',
      gstTreatment				: 	GSTTreatment.Registered,
      placeOfSupply				: 	PlaceOfSupply.TN
    },
    validateOnChange: false,
    validationSchema			: 	validation,
    onSubmit
  });

  function onSubmit(values: any) {
    setLoading(true);
      if(editMode) {
        setEditMode(false);
        console.log('editMode', editMode);
        customerService.editCustomer(props.match.params.id, new Customer(values)).then(data => {
          setLoading(false);
          showSuccessSnackbar(snackbar, 'Customer updated successfully!', true)
          props.history.push('/dashboard/customers')
          // formik.resetForm();
        }).catch(() => {
          setLoading(false);
          showErrorSnackbar(snackbar, 'Something went wrong!', true)
        }); 
      } else {
        customerService.addCustomer(new Customer(values)).then(data => {
          setLoading(false);
          showSuccessSnackbar(snackbar, 'Customer saved successfully!', true)
          props.history.push('/dashboard/customers')
          // formik.resetForm();
        }).catch(() => {
          setLoading(false);
          showErrorSnackbar(snackbar, 'Something went wrong!', true)
        }); 
      }
  }

  const patchValue = async (id: string) => {
    setPatch(true);
    setLoading(true);
    setEditMode(true);
    // const customer = await customerService.getCustomer(id);
    customerService.getCustomer(id, (customer: any) => {
      formik.setValues(customer);
      console.log(customer)
      setLoading(false);
      setPatch(false);
    })
  }

  useEffect(() => {

    if (props) {
      if (!props.match.url.endsWith('new')) {
        patchValue(props.match.params.id);
      }
    }
  }, []);

  const handleCancel = () => {
    showSnackbar(snackbar, 'Cancelled!', true, 1000)
    props.history.push('/dashboard/customers')
  }


  return (
    <div className={classes.main}>
      <header className={classes.header}>
        <FormPageHeader title="Add Customer" update={editMode} saveHandler={formik.handleSubmit} cancelHandler={handleCancel}/>
      </header>

      <form className={classes.body}>
        <div className={classes.row1}>
            <div className={classes.column1}>
                <div style={{display: 'flex'}}>
                    <span>
                      <label htmlFor="" style={{color:"#7F7F7F"}}>{ formik.touched.firstName && formik.errors.firstName ? <span>{formik.errors.firstName}</span> : null }</label><br/>
                      <input
                        className={classes.halftextholder}
                        placeholder="First Name"
                        onFocus={(e: any) => e.target.select()}
                        { ...formik.getFieldProps('firstName') }
                      />
                    </span>
                    <span>
                      <label htmlFor="" style={{color:"#7F7F7F"}}>{ formik.touched.lastName && formik.errors.lastName ? <span>{formik.errors.lastName}</span> : null }</label><br/>
                      <input
                        className={classes.halftextholder}
                        placeholder="Last Name"
                        onFocus={(e: any) => e.target.select()}
                        { ...formik.getFieldProps('lastName') }
                      />
                    </span>
                </div>
                <div>
                    <label htmlFor="" style={{color:"#7F7F7F"}}>Customer Email { formik.touched.email && formik.errors.email ? <span>{formik.errors.email}</span> : null }</label><br/>
                    <TextField
                      InputProps={inputProps}
                      className={classes.fulltextholder}
                      onFocus={(e: any) => e.target.select()}
                      { ...formik.getFieldProps('email') }
                    />
                </div>
            </div>
            <div>
                <div>
                    <label htmlFor="" style={{color:"#7F7F7F"}}>{ formik.touched.companyName && formik.errors.companyName ? <span>{formik.errors.companyName}</span> : null }</label><br/>
                    <input
                      className={classes.fulltextholder}
                      placeholder="Company Name"
                      onFocus={(e: any) => e.target.select()}
                      { ...formik.getFieldProps('companyName') }
                    />
                </div>
                <div style={{display:"flex"}}>
                    <div>
                        <label htmlFor="" style={{color:"#7F7F7F"}}>Phone { formik.touched.phone && formik.errors.phone ? <span>{formik.errors.phone}</span> : null }</label><br/>
                        <TextField
                          InputProps={inputProps}
                          className={classes.halftext}
                          onFocus={(e: any) => e.target.select()}
                        { ...formik.getFieldProps('phone') }
                        />
                    </div>
                    <div>
                        <label htmlFor="" style={{color:"#7F7F7F"}}>Opening Balance { formik.touched.openingBalance && formik.errors.openingBalance ? <span>{formik.errors.openingBalance}</span> : null }</label><br/>
                        <TextField
                          InputProps={inputProps}
                          className={classes.halftext}
                          disabled={editMode}
                          onFocus={(e: any) => e.target.select()}
                        { ...formik.getFieldProps('openingBalance') }
                        />
                    </div>
                </div>
            </div>
        </div>
        <div className={classes.row2}>
            <div className={classes.column1}>
                <div>
                    <div style={{marginBottom:"20px", marginTop:"-20px", fontWeight:800, color:"#112B42", fontSize:"14px"}}><label>Billing Address</label></div>
                    <label htmlFor="" className={classes.marginbottom} style={{color:"#7F7F7F"}}>Address { formik.touched.address && formik.errors.address ? <span>{formik.errors.address}</span> : null } </label><br/>
                    <TextField
                      multiline
                      rows={6}
                      InputProps={inputProps}
                      className={classes.textaddress}
                      onFocus={(e: any) => e.target.select()}
                      { ...formik.getFieldProps('address') }
                    />
                </div>
            
                <div style={{display:"flex"}}>
                    <div>
                        <label htmlFor="" style={{color:"#7F7F7F"}}>City { formik.touched.city && formik.errors.city ? <span>{formik.errors.city}</span> : null } </label><br/>
                        <TextField
                          InputProps={inputProps}
                          className={classes.halftext}
                          onFocus={(e: any) => e.target.select()}
                          { ...formik.getFieldProps('city') }
                        />
                    </div>
                    <div>
                        <label htmlFor="" style={{color:"#7F7F7F"}}>State { formik.touched.state && formik.errors.state ? <span>{formik.errors.state}</span> : null } </label><br/>
                        <TextField
                          InputProps={inputProps}
                          className={classes.halftext}
                          onFocus={(e: any) => e.target.select()}
                          { ...formik.getFieldProps('state') }
                        />
                    </div>
                </div>
                <div>
                    <label htmlFor="" style={{color:"#7F7F7F"}}>Zipcode { formik.touched.zipcode && formik.errors.zipcode ? <span>{formik.errors.zipcode}</span> : null } </label><br/>
                    <TextField
                      InputProps={inputProps}
                      className={classes.halftext}
                      onFocus={(e: any) => e.target.select()}
                      { ...formik.getFieldProps('zipcode') }
                    />
                </div>
            </div>
            <div className={classes.column2}>
                <div>
                <div style={{marginBottom:"20px", marginTop:"-20px", fontWeight:800, color:"#112B42"}}><label>Tax Details { formik.touched.gstTreatment && formik.errors.gstTreatment ? <span>{formik.errors.gstTreatment}</span> : null } </label></div>
                    <label htmlFor="" style={{fontSize:"14px"}}>GST Treatment</label><br/>
                    <TextField
                      InputProps={inputProps}
                      className={classes.fulldrop}
                      select
                      SelectProps={{IconComponent:  (props) => <ExpandMoreIcon {...props}/>}}
                      { ...formik.getFieldProps('gstTreatment') }
                    >
                      <MenuItem value={GSTTreatment.Registered}>{GSTTreatment.Registered}</MenuItem>
                      <MenuItem value={GSTTreatment.Unregistered}>{GSTTreatment.Unregistered}</MenuItem>
                      <MenuItem value={GSTTreatment.None}>{GSTTreatment.None}</MenuItem>
                    </TextField>
                </div>
                <div>
                    <div style={{display:"flex",justifyContent:"space-between"}}>
                    <label htmlFor="" style={{fontSize:"14px"}}>{formik.values.gstTreatment === GSTTreatment.Unregistered ? 'PAN' : 'GSTIN'} { formik.touched.gstin && formik.errors.gstin ? <span>{formik.errors.gstin}</span> : null } </label>
                        {/* <label htmlFor="" style={{marginRight:"20px", color:"#0079e4"}}>Get Tax Payer Details</label> */}
                    </div>
                    <TextField
                      InputProps={inputProps}
                      className={classes.fulltext}
                      onFocus={(e: any) => e.target.select()}
                      { ...formik.getFieldProps('gstin') }
                    />
                </div>
                <div>
                    <label htmlFor="" style={{fontSize:"14px"}}>Place of Supply { formik.touched.placeOfSupply && formik.errors.placeOfSupply ? <span>{formik.errors.placeOfSupply}</span> : null } </label><br/>
                    <TextField
                      InputProps={inputProps}
                      className={classes.fulldrop}
                      select
                      SelectProps={{IconComponent:  (props) => <ExpandMoreIcon {...props}/>}}
                      { ...formik.getFieldProps('placeOfSupply') }
                    >
                      <MenuItem value={PlaceOfSupply.TN}>{PlaceOfSupply.TN}</MenuItem>
                      <MenuItem value={PlaceOfSupply.KL}>{PlaceOfSupply.KL}</MenuItem>
                      <MenuItem value={PlaceOfSupply.KN}>{PlaceOfSupply.KN}</MenuItem>
                    </TextField>
                </div>

            </div>
        </div>
      </form>
      <Loading loading={loading} text={patch ? 'Loading....': null}/>
    </div>   
  );
}